export enum RemitoTypes {
  MGO = "MGO",
  FREE = "Free",
  BALANZA = "Balanza"
}

export class RemitoTypeMapping {
  public static MAPPING = new Map<string, RemitoTypes>([
    ["FRE", RemitoTypes.FREE],
    ["RO", RemitoTypes.MGO],
    ["WE", RemitoTypes.MGO],
    ["BAL", RemitoTypes.BALANZA],
  ]);
}
